import { api } from 'API'

interface ReleaseNote {
  id?: number
  version: string
  title: string
  content: string
  releaseDate: string
  published: boolean
  sortOrder: number
}

export const getReleaseNotes = async (): Promise<ReleaseNote[]> => {
  const response = await api.get<ReleaseNote[]>('/release-notes')
  return response.data
}

export const getPublishedReleaseNotes = async (): Promise<ReleaseNote[]> => {
  const response = await api.get<ReleaseNote[]>('/release-notes/published')
  return response.data
}

export const getReleaseNote = async (id: number): Promise<ReleaseNote> => {
  const response = await api.get<ReleaseNote>(`/release-notes/${id}`)
  return response.data
}

export const createReleaseNote = async (releaseNote: Omit<ReleaseNote, 'id'>): Promise<ReleaseNote> => {
  const response = await api.post<ReleaseNote>('/release-notes', releaseNote)
  return response.data
}

export const updateReleaseNote = async (id: number, releaseNote: Partial<ReleaseNote>): Promise<void> => {
  await api.patch(`/release-notes/${id}`, releaseNote)
}

export const deleteReleaseNote = async (id: number): Promise<void> => {
  await api.delete(`/release-notes/${id}`)
}

export const formatReleaseNoteWithAI = async (
  content: string,
  version: string,
  title?: string
): Promise<{formattedTitle: string; formattedContent: string}> => {
  const response = await api.post<{formattedTitle: string; formattedContent: string}>(
    '/release-notes/ai-format',
    {
      content,
      version,
      title,
    }
  )
  return response.data
}

export const generateReleaseNoteWithAI = async (
  changes: string[],
  version: string
): Promise<{suggestedTitle: string; formattedContent: string}> => {
  const response = await api.post<{suggestedTitle: string; formattedContent: string}>(
    '/release-notes/ai-generate',
    {
      changes,
      version,
    }
  )
  return response.data
}
